import { ActionTree } from "vuex";
import API from "@/axios";
import { RootState } from "@/store/types";
import { ThemeState, FontFamily, IllustrationEntry } from "../types";
import initialState from "./initialState";

const actions: ActionTree<ThemeState, RootState> = {
  fetchTheme({ commit }) {
    return API.get("/settings/datastore/theme").then((res) => {
      const result = res.data;
      if (result) {
        const { value: json } = result.data;
        const theme: ThemeState = JSON.parse(json);
        if (theme) {
          commit("setAccentColor", theme.accentColor);
          commit("setSecondaryColor", theme.secondaryColor);
          commit("setGradientStart", theme.gradient.start);
          commit("setGradientStop", theme.gradient.stop);
          commit("setFontFamily", theme.fontFamily);
          commit("setWelcomeIllustration", theme.illustrations.welcome);
          commit(
            "setPrepareSelfieIllustration",
            theme.illustrations.prepareSelfie
          );
          commit(
            "setChooseCountryIllustration",
            theme.illustrations.chooseCountry
          );
          commit(
            "setDriversLicenseFrontIllustration",
            theme.illustrations.driversLicenseFront
          );
          commit(
            "setDriversLicenseBackIllustration",
            theme.illustrations.driversLicenseBack
          );
          commit(
            "setNationalIdFrontIllustration",
            theme.illustrations.nationalIdFront
          );
          commit(
            "setNationalIdBackIllustration",
            theme.illustrations.nationalIdBack
          );
          commit("setPassportIllustration", theme.illustrations.passport);
        }
      }
    });
  },
  publishTheme({ state }) {
    return API.post("/settings/datastore", {
      key: "theme",
      value: JSON.stringify(state),
    });
  },
  resetTheme({ commit }) {
    const theme = initialState;
    commit("setAccentColor", theme.accentColor);
    commit("setSecondaryColor", theme.secondaryColor);
    commit("setGradientStart", theme.gradient.start);
    commit("setGradientStop", theme.gradient.stop);
    commit("setFontFamily", theme.fontFamily);
    commit("setWelcomeIllustration", theme.illustrations.welcome);
    commit("setPrepareSelfieIllustration", theme.illustrations.prepareSelfie);
    commit("setChooseCountryIllustration", theme.illustrations.chooseCountry);
    commit(
      "setDriversLicenseFrontIllustration",
      theme.illustrations.driversLicenseFront
    );
    commit(
      "setDriversLicenseBackIllustration",
      theme.illustrations.driversLicenseBack
    );
    commit(
      "setNationalIdFrontIllustration",
      theme.illustrations.nationalIdFront
    );
    commit("setNationalIdBackIllustration", theme.illustrations.nationalIdBack);
    commit("setPassportIllustration", theme.illustrations.passport);
  },
  setAccentColor({ commit }, accentColor) {
    commit("setAccentColor", accentColor);
  },
  setSecondaryColor({ commit }, secondaryColor) {
    commit("setSecondaryColor", secondaryColor);
  },
  setFontFamily({ commit }, fontFamily: FontFamily) {
    commit("setFontFamily", fontFamily);
  },
  setGradientStart({ commit }, start: string) {
    commit("setGradientStart", start);
  },
  setGradientStop({ commit }, stop: string) {
    commit("setGradientStop", stop);
  },
  setWelcomeIllustration({ commit }, illustration: IllustrationEntry) {
    commit("setWelcomeIllustration", illustration);
  },
  setPrepareSelfieIllustration({ commit }, illustration: IllustrationEntry) {
    commit("setPrepareSelfieIllustration", illustration);
  },
  setChooseCountryIllustration({ commit }, illustration: IllustrationEntry) {
    commit("setChooseCountryIllustration", illustration);
  },
  setDriversLicenseFrontIllustration(
    { commit },
    illustration: IllustrationEntry
  ) {
    commit("setDriversLicenseFrontIllustration", illustration);
  },
  setDriversLicenseBackIllustration(
    { commit },
    illustration: IllustrationEntry
  ) {
    commit("setDriversLicenseBackIllustration", illustration);
  },
  setNationalIdFrontIllustration({ commit }, illustration: IllustrationEntry) {
    commit("setNationalIdFrontIllustration", illustration);
  },
  setNationalIdBackIllustration({ commit }, illustration: IllustrationEntry) {
    commit("setNationalIdBackIllustration", illustration);
  },
  setPassportIllustration({ commit }, illustration: IllustrationEntry) {
    commit("setPassportIllustration", illustration);
  },
};

export default actions;
